import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-dark text-white py-5">
      <div className="container">
        <div className="row">
          {/* Colonna brand */}
          <div className="col-md-12 text-center">
            <h5 className="fw-bold mb-4">Bookolica</h5>
            <p className="mb-4">
              Casa editrice indipendente che coltiva storie autentiche 
              radicate nella bellezza della parola scritta.
            </p>
            <div className="d-flex justify-content-center gap-2 mb-4">
              <a href="https://www.instagram.com/bookolicaspace" target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-outline-light rounded-circle">
                <i className="bi bi-instagram"></i>
              </a>
            </div>
          </div>
        </div>
        
        <hr className="my-4 opacity-25" />
        
        <div className="row">
          <div className="col-md-6 text-center text-md-start">
            <p className="mb-0 text-white-50">
              &copy; {new Date().getFullYear()} Bookolica. Tutti i diritti riservati.
            </p>
          </div>
          <div className="col-md-6 text-center text-md-end">
            <p className="mb-0 text-white-50">
              Dove i libri mettono radici
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 